import { EmployeeInfo } from '../../models'

export const DEFAULT_EMPLOYEE_INFO: EmployeeInfo = {
  mail: '',
  vita: '',
  pictureUrl: '',
}
